import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {
    optInCoach_clearUserOptOutOfABTesting as SetTeacherOptInToResearchData,
    optInCoachVariables as SetTeacherOptInToResearchVariables,
} from "./__graphql-types__/optInCoach.ts";
import type {
    optOutCoach_userOptOutOfABTesting as SetTeacherOptOutOfResearchData,
    optOutCoachVariables as SetTeacherOptOutOfResearchVariables,
} from "./__graphql-types__/optOutCoach.ts";
import type {
    setHasFormalTeacherStatus_setSettings as SetTeacherTOSDataSettings,
    setHasFormalTeacherStatusVariables as SetTeacherTOSVariables,
} from "./__graphql-types__/setHasFormalTeacherStatus.ts";
import type {
    setHasFormalTeacherStatusFixed as SetTeacherTOSDataFixed,
    setHasFormalTeacherStatusFixedVariables as SetTeacherTOSVariablesFixed,
} from "./__graphql-types__/setHasFormalTeacherStatusFixed.ts";

// TODO: Typing on this mutation was incorrect; use TEACHER_FORMAL_TOS_MUTATION instead
export const TEACHER_TOS_MUTATION: GqlOperation<
    SetTeacherTOSDataSettings,
    SetTeacherTOSVariables
> = gqlOp(gql`
    mutation setHasFormalTeacherStatus($tosForFormalTeacherStatus: Boolean) {
        setSettings(tosForFormalTeacherStatus: $tosForFormalTeacherStatus) {
            user {
                id
                tosForFormalTeacherStatus
            }
            errors {
                code
            }
        }
    }
`);

export const TEACHER_FORMAL_TOS_MUTATION: GqlOperation<
    SetTeacherTOSDataFixed,
    SetTeacherTOSVariablesFixed
> = gqlOp(gql`
    mutation setHasFormalTeacherStatusFixed(
        $tosForFormalTeacherStatus: Boolean
    ) {
        setSettings(tosForFormalTeacherStatus: $tosForFormalTeacherStatus) {
            user {
                id
                tosForFormalTeacherStatus
            }
            errors {
                code
            }
        }
    }
`);

export const TEACHER_OPT_OUT_OF_RESEARCH_MUTATION: GqlOperation<
    SetTeacherOptOutOfResearchData,
    SetTeacherOptOutOfResearchVariables
> = gqlOp(gql`
    mutation optOutCoach($kaid: String) {
        userOptOutOfABTesting(kaid: $kaid) {
            user {
                id
                kaid
            }
            error {
                code
            }
        }
    }
`);

export const TEACHER_OPT_IN_TO_RESEARCH_MUTATION: GqlOperation<
    SetTeacherOptInToResearchData,
    SetTeacherOptInToResearchVariables
> = gqlOp(gql`
    mutation optInCoach($kaid: String) {
        clearUserOptOutOfABTesting(kaid: $kaid) {
            user {
                id
                kaid
            }
            error {
                code
            }
        }
    }
`);
